var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-separator"},_vm._l((_vm.separatorColors),function(color,index){return _c('div',{key:index,staticClass:"separator",style:({ 'background-color': color })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }